import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { addReduxDevtoolsMiddleware } from './middlewares/reduxDevTools';
import {
  sfPortalMiddleware,
  connectToSfPortal,
  PORTAL_EVENTS,
  triggerToSfPortal,
} from './sfPortal';

export const rootReducer = asyncReducers =>
  combineReducers({
    _: (state = {}) => state,
    ...asyncReducers,
  });

export const rootStore = () => {
  const store = createStore(
    rootReducer(),
    {},
    compose(
      applyMiddleware(thunk),
      applyMiddleware(sfPortalMiddleware),
      addReduxDevtoolsMiddleware(),
    ),
  );

  store.asyncReducers = {};
  store.rootReducer = rootReducer;

  // Listen to all events from manomano-sf to dispatch them to the store
  connectToSfPortal(store);
  // Then trigger a "ready" event
  setTimeout(() => {
    triggerToSfPortal(PORTAL_EVENTS.ready);
  }, 0);

  return store;
};

export default rootStore();
